"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = require("@ux/intents");
var _intents2 = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _default = exports.default = function () {
  _intents2.default.create('@ux/tabs', {
    styleProperties: [_intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BORDER_COLOR],
    features: {
      [_intents.enums.features.ITEM]: {
        interactions: [_intents.enums.interactions.HOVERED],
        expressions: [_intents.enums.expressions.CHOSEN],
        styleProperties: [_intents.enums.properties.FONT_FAMILY, _intents.enums.properties.FONT_SIZE, _intents.enums.properties.FONT_WEIGHT, _intents.enums.properties.LINE_HEIGHT, _intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BACKGROUND_COLOR]
      }
    }
  });

  /**
   * uxTabs Fallback values
   */
  _intents2.default.uxTabs.borderColor = _intents2.default.ux.box.borderColor;
  _intents2.default.uxTabs.foregroundColor = _intents2.default.ux.box.foregroundColor;
  _intents2.default.uxTabs.itemHovered.foregroundColor = _intents2.default.ux.box.foregroundColor;
  _intents2.default.uxTabs.itemChosen.foregroundColor = _intents2.default.ux.box.foregroundColor;
  _intents2.default.uxTabs.itemChosenHovered.foregroundColor = _intents2.default.ux.box.foregroundColor;
  return _intents2.default;
}();